/**
 * Bugfix: RTC-986
 * We have different criteria for creating a chat room title manually versus
 * the name of the session.
 * Session name of "Demo: Compare a Face" fails to create the chat room
 * since ":" is not allowed.
 * Here is the server regex: "^[^{}\\[\\]<>:@]{1,100}$"
 * In NewChatRoom, we limit the title to 100 characters, so matching that here.
 */
export const sanitizeChatRoomTitle = (title) => {
  const NEW_CHAT_ROOM_MAX_LENGTH = 100

  if (title) {
    const regex = new RegExp('[{}\\[\\]\\.,\\/—<>:@]', 'gi')
    let validTitle = title
      .replace(regex, ' ')
      .replace(/\s+/g, ' ') // reduce duplicate spaces
      .trim()

    if (validTitle.length > NEW_CHAT_ROOM_MAX_LENGTH) {
      validTitle = `${validTitle.trim().substring(0, 47)}...`
    }

    return validTitle
  }

  return title
}

export const dummy = () => {}
